module.exports = __webpack_public_path__ + "img/rightTop1.8121cb03.png";